import React, { useCallback, useEffect, useState } from "react";
import { useApi } from "../../hooks/api";
import { DashboardContainer } from "./style";
import { useGlobal } from "../../hooks/global";
import { getAtualDate } from "../Dashboard/utils";
import { PointsCards } from "../Dashboard/PointsCards";
import { RankingClients } from "../Dashboard/RankingClients";
import { DashboardPage } from "../../components/DashboardPage";
import { DashboardHeader } from "../Dashboard/DashboardHeader";
import { correct_date_filter, setUpConsultation } from "../../services/generalServices";

const initalRange = {
  from: { day: 1, month: 1, year: 2024 },
  to: getAtualDate({ daysBefore: 0 }),
};

export const Points: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [exchangeRate, setExchangeRate] = useState(50);
  const [controlRender, setControlRender] = useState(false);
  const [pointsStatistics, setPointsStatistics] = useState({});
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());
  const [range, setRange] = useState<{ from: any; to: any }>(initalRange);
  const [dateType, setDateType] = useState<string>("CREATED_DATE");

  const { api } = useApi()
  const { theme, getCorrectMaxWidth, notify, loadingResize } = useGlobal();

  const search = useCallback(async () => {
    setLoading(true)

    try {
      const date_init = range.from ? range.from : (range.to ? range.to : null)
      const date_end = range.to ? range.to : (range.from ? range.from : null)
      const start_date = date_init ? correct_date_filter(date_init) : null
      const end_date = date_end ? correct_date_filter(date_end) : null

      const query = setUpConsultation({ end_date: (new Date()).toISOString().split('T')[0], start_date: (new Date('2022-01-01')).toISOString().split('T')[0] })

      const [{ data: generalData }, { data: constantsData }] = await Promise.all([
        api.get('/general-points' + '?' + query),
        api.get('/constants')
      ])

      setPointsStatistics(generalData)

      setExchangeRate(constantsData.EXCHANGE_RATE)

      setLastUpdate(new Date())
    } catch (err) {
      notify('Erro ao buscar dados do dashboard', 'error')
    }

    setLoading(false)
  }, [range])

  useEffect(() => { search() }, [controlRender, range])

  useEffect(() => { setControlRender((prev) => !prev) }, [loadingResize])

  const children = (
    <DashboardContainer>
      <DashboardHeader
        lastUpdate={lastUpdate}
        loading={loading}
        onSearch={() => setControlRender((prev) => !prev)}
        range={range}
        setRange={setRange}
        setDateType={setDateType}
        title="Gestão de pontos"
        noDate
      />
      <PointsCards
        loading={loading}
        statistics={pointsStatistics as any}
        exchange_rate={exchangeRate}
      />
      <RankingClients
        theme={theme}
        range={range}
        maxWidth={getCorrectMaxWidth()}
        minWidth={250}
      />
    </DashboardContainer>
  )

  return (
    <DashboardPage>
      {controlRender && children}
      {!controlRender && children}
    </DashboardPage>
  )
};